import { MouseEventHandler } from 'react';
import { useTranslation } from 'react-i18next';

import { BellOutline, Box, forwardRef, IconButton, rem, Tooltip } from '@bonusly/design-system';

import { CountBadge } from '../../../../components/badge/count-badge';

interface NotificationIconProps {
	handleClick: MouseEventHandler;
	unreadCount: number;
}
export const NotificationIcon = forwardRef<NotificationIconProps, 'button'>(({ unreadCount, handleClick }, ref) => {
	const { t } = useTranslation('navigation');
	return (
		<Tooltip label={t('notification.menu_label')} placement="bottom-start">
			<Box ref={ref}>
				<CountBadge count={unreadCount > 0 ? unreadCount : undefined}>
					<IconButton
						id="primary-nav-notifications"
						data-testid="primary-nav-notifications"
						_active={{ bg: 'gray.100', transform: 'scale(0.95)' }}
						_hover={{ bg: 'gray.100' }}
						aria-label={t('notification.header')}
						backgroundColor="gray.50"
						borderRadius="full"
						color="gray.900"
						fontSize="lg"
						boxSize={{ base: rem(40), xs: rem(44) }}
						icon={<BellOutline size="md" />}
						onClick={handleClick}
					/>
				</CountBadge>
			</Box>
		</Tooltip>
	);
});
